import { useMatch } from 'react-router-dom'
import { useChannel } from 'src/provider/ChannelContextProvider'

const usePathMatch = () => {
  const { channel } = useChannel()
  return {
    match_search_result: !!useMatch(`/${channel}/search/result/:search_word`),
    match_self_register: !!useMatch(`/${channel}/coupon/self_register`),
    match_brand_detail: !!useMatch(`/${channel}/brand_list/:categoryNumber/:brandNumber/:status`),
    match_main: !!useMatch(`/${channel}/main`),
    match_coupon_map: !!useMatch(`/${channel}/map`),
    match_always_discount_coupon: !!useMatch(`/${channel}/always/:alwaysCategoryNumber`),
    match_brand_list: !!useMatch(`/${channel}/brand_list`),
    match_join_cert: !!useMatch(`/${channel}/join/cert`),
  }
}
export default usePathMatch
